import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { client } from '../client';
import { feedQuery, searchQuery, familyQuery } from '../utils/data';
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner.jsx';

const Feed = ({ user, setView }) => {
  const [pins, setPins] = useState();
  const [loading, setLoading] = useState(false);
  const { categoryId } = useParams();
  const [familyArray, setFamilyArray] = useState();
  const [param, setParam] = useState();
  const id = '\'' + user?._id + '\'';

  useEffect(() => {
    setLoading(true);
    if (categoryId) {
      
      const query = searchQuery(categoryId);

      client.fetch(query).then((data) => {
        setPins(data);
        setView(data[0].familyName);
        setLoading(false);
      });

    } else {
      const fQuery = feedQuery(id);
      client.fetch(fQuery).then((data) => {
          setPins(data);
          setLoading(false);
          setView("Home");
        });

    }
  }, [categoryId, id]);

  const ideaName = categoryId || 'new';

  if (loading) {
    return (
      <Spinner message={`Loading ${ideaName}`} />
    );
  }

  if (!pins?.length) { return <h2>Nothing to see here...</h2> }

  return (
    <div>
      {pins && (
        <MasonryLayout pins={pins} />
      )}
    </div>
  );
};

export default Feed;

